import { useFormContext } from 'react-hook-form';

import { type RejectedProctorRequestEditionFormInput } from './schemas';

function useRejectedProctorRequestEditionForm() {
  const context = useFormContext<RejectedProctorRequestEditionFormInput>();

  if (!context) {
    throw new Error(
      'useRejectedProctorRequestEditionForm must be used within a RejectedProctorRequestEditionFormProvider',
    );
  }

  return context;
}

export { useRejectedProctorRequestEditionForm };
